// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templateSchemeWrapper {\n  position: relative;\n  background-color: #e8eef7;\n  max-width: 1340px;\n}\n.templateSchemeWrapper .addNew {\n  margin-top: 20px;\n  margin-bottom: 98px;\n  margin-left: 5px;\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n/* identical to box height, or 150% */\n/* Dark / 15 */\n  color: #1a1d24;\n}", ""]);
// Exports
module.exports = exports;
